import { createSlice } from "@reduxjs/toolkit";

const systemNotificationSlice = createSlice({
  name: "systemNotification",
  initialState: {
    isLoading: false,
    notificationList: [],
    notificationDetail: null,
    pagination: {
      page: 1,
      limit: 20,
      total: 0,
    },
  },
  reducers: {
    getSystemNotificationListRequest: {
      reducer: (state) => {
        state.isLoading = true;
        return state;
      },
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    getSystemNotificationListSuccess: {
      reducer: (state, action) => {
        console.log("getSystemNotificationListSuccess payload:", action.payload);
        console.log("action.payload.data:", action.payload?.data);
        console.log("action.payload.data.notifications:", action.payload?.data?.notifications);
        
        return {
          ...state,
          isLoading: false,
          notificationList: action.payload?.notifications || [],
          pagination: {
            page: action.payload.pagination?.page || 1,
            limit: action.payload.pagination?.limit || 20,
            total: action.payload.pagination?.total || 0,
          },
        };
      },
      prepare: (payload, meta) => ({ payload, meta }),
    },
    createSystemNotificationRequest: {
      reducer: (state) => {
        state.isLoading = true;
        return state;
      },
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    createSystemNotificationSuccess: {
      reducer: (state) => ({
        ...state,
        isLoading: false,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    getSystemNotificationDetailRequest: {
      reducer: (state) => {
        state.isLoading = true;
        state.notificationDetail = null;
        return state;
      },
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    getSystemNotificationDetailSuccess: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
        notificationDetail: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    updateSystemNotificationRequest: {
      reducer: (state) => {
        state.isLoading = true;
        return state;
      },
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    updateSystemNotificationSuccess: {
      reducer: (state) => ({
        ...state,
        isLoading: false,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    deleteAllSystemNotificationsRequest: {
      reducer: (state) => {
        state.isLoading = true;
        return state;
      },
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    deleteAllSystemNotificationsSuccess: {
      reducer: (state) => ({
        ...state,
        isLoading: false,
        notificationList: [],
        pagination: {
          page: 1,
          limit: 20,
          total: 0,
        },
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    retrySystemNotificationRequest: {
      reducer: (state) => {
        state.isLoading = true;
        return state;
      },
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    retrySystemNotificationSuccess: {
      reducer: (state) => ({
        ...state,
        isLoading: false,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    stopLoading: (state) => ({
      ...state,
      isLoading: false,
    }),
  },
});

export const {
  getSystemNotificationListRequest,
  getSystemNotificationListSuccess,
  createSystemNotificationRequest,
  createSystemNotificationSuccess,
  getSystemNotificationDetailRequest,
  getSystemNotificationDetailSuccess,
  updateSystemNotificationRequest,
  updateSystemNotificationSuccess,
  deleteAllSystemNotificationsRequest,
  deleteAllSystemNotificationsSuccess,
  retrySystemNotificationRequest,
  retrySystemNotificationSuccess,
  stopLoading,
} = systemNotificationSlice.actions;

export default systemNotificationSlice.reducer; 